/* ============================================================
   CIRI PERCUMA PRO STUDIO — status claim ikut ciri
   ============================================================
   Keputusan user 2026-09-26: ciri PRO Studio yang sudah siap
   (Shortcut / · CTA beg kuning) PERCUMA sehingga 30 Nov 2026, tetapi
   pelanggan WAJIB claim dahulu (tanda dia maklum ia sebahagian pakej
   tambahan berbayar). Claim IKUT CIRI — setiap ciri popup + butang
   sendiri. Termasuk trial. Agent Saya TIDAK termasuk (kekal ikut SMART).

   Rekod: `users/{uid}.ciriPercuma.{ciri}` = { dituntutPada, sehingga }
   — medan DILINDUNGI, ditulis oleh Cloud Function `tuntutCiriPercuma`
   sahaja. Rules `shortcutSlash` + `ctaTemplates` menyemak `sehingga`.

   Selepas 30 Nov: status 'tamat' → ciri dikunci; data pelanggan KEKAL.
   Pakej PRO Studio berbayar belum wujud — bila ia dicipta, tambah
   syarat kelayakannya dalam `statusCiri` (dan rules).

   ⚠️ KEMBAR: `functions/ciriPercuma.js` (CIRI_PERCUMA, TARIKH_TAMAT_PERCUMA)
      + `firestore.rules` (shortcutSlash, ctaTemplates, protectedUserFields).
   ============================================================ */

import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

// ★ [2026-11-01] Dilanjutkan 31 Okt → 30 Nov 2026 (arahan user). Rekod claim sedia ada dikemas kini oleh skrip berasingan.
export const CIRI = { SHORTCUT: 'shortcut', CTA: 'cta' };
export const TARIKH_TAMAT = new Date('2026-11-30T23:59:59+08:00');

const keDate = (v) => {
    if (!v) return null;
    if (typeof v.toDate === 'function') return v.toDate();
    if (typeof v.seconds === 'number') return new Date(v.seconds * 1000);
    const d = new Date(v);
    return Number.isNaN(d.getTime()) ? null : d;
};

/* Rekod mentah satu ciri → { dituntutPada: Date|null, sehingga: Date|null } */
export const rekodCiri = (ciriPercuma, ciri) => {
    const r = ciriPercuma?.[ciri];
    return { dituntutPada: keDate(r?.dituntutPada), sehingga: keDate(r?.sehingga) };
};

/* 'admin' | 'aktif' | 'belum' | 'tamat' */
export function statusCiri(ciriPercuma, ciri, isAdmin = false, kini = new Date()) {
    if (isAdmin) return 'admin';
    const { sehingga } = rekodCiri(ciriPercuma, ciri);
    if (sehingga) return kini < sehingga ? 'aktif' : 'tamat';
    return kini < TARIKH_TAMAT ? 'belum' : 'tamat';
}

export const bolehGunaCiri = (status) => status === 'admin' || status === 'aktif';

export async function tuntutCiri(ciri) {
    const fn = httpsCallable(functions, 'tuntutCiriPercuma');
    const res = await fn({ ciri });
    return res.data;
}

/* "Nanti dulu" → sorok popup ciri itu untuk HARI INI sahaja, pada browser ini.
   ⛔ Tulis HANYA dari klik butang, jangan dari useEffect. */
const kunciNanti = (ciri) => `sesaat_ciri_percuma_nanti_${ciri}`;
const hariIni = () => new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Kuala_Lumpur' });
export const nantiHariIni = (ciri) => {
    try { return localStorage.getItem(kunciNanti(ciri)) === hariIni(); } catch { return false; }
};
export const tandaNanti = (ciri) => {
    try { localStorage.setItem(kunciNanti(ciri), hariIni()); } catch { /* storan disekat — abaikan */ }
};

export const formatTarikh = (d, bahasa = 'ms') => (d
    ? d.toLocaleDateString(bahasa === 'en' ? 'en-GB' : 'ms-MY', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'Asia/Kuala_Lumpur' })
    : '');
